var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("bg-loader " + (this.dark && 'bg-loader--dark') + " " + (this.contentLoader &&
      'bg-loader--content'))})}
var staticRenderFns = []

export { render, staticRenderFns }